import { RESET_STATE, SET_ICEPACKS, SET_IS_ICEPACKS_LOADING, SET_PAGINATION } from './actions';

export const initialState = {
	icepacks: [],
	isIcepacksLoading: false,
	pagination: null,
};

const icepacksContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ICEPACKS:
			return {
				...state,
				icepacks: payload,
			};
		case SET_IS_ICEPACKS_LOADING:
			return {
				...state,
				isIcepacksLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default icepacksContainerReducer;
